import { useObserver } from "mobx-react";
import { useState, useEffect } from "react";
import { MdInfoOutline } from "react-icons/md";

export default function PercentageInput(props) {
  const [inputValue, setInputValue] = useState(
    (props?.value ?? props?.defaultValue)?.toString().replace("%", "") ?? "",
  );
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    setInputValue(props?.value?.replace("%", ""));
  }, [props.value]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showTooltip && !event.target.closest(".group")) {
        setShowTooltip(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [showTooltip]);

  const handleChange = (e) => {
    let value = e?.target?.value?.replace("%", "");
    // Allow only numbers and limit to 3 digits
    if (/^\d{0,3}$/.test(value)) {
      const numericValue = parseFloat(value);
      if (value === "" || (numericValue >= 1 && numericValue <= 100)) {
        setInputValue(value);
        props.setValue(value);
        props?.action(e);
      }
    }
  };

  // const handleBlur = () => {
  //   if (inputValue !== "" && !isNaN(inputValue)) {
  //     const numericValue = parseFloat(inputValue);
  //     if (numericValue >= 1 && numericValue <= 100) {
  //       setInputValue(numericValue.toFixed(2) + "%");
  //       props.setValue(numericValue.toFixed(2) + "%");
  //     } else {
  //       setInputValue("");
  //       props.setValue("");
  //     }
  //   }
  // };

  // const handleFocus = () => {
  //   if (inputValue.endsWith("%")) {
  //     setInputValue(inputValue.slice(0, -1));
  //   }
  // };

  return useObserver(() => (
    <div className="flex flex-col gap-2">
      <label className="font-sans flex justify-between items-center pr-6 w-full text-[#6D6B6B] ml-3">
        {props.label}
        {/* <div className="tooltip w-6 mr-2">
          <img src={info} alt="info" className="w-6 h-6  inline-block ml-2" />
          <span className="tooltiptext">{props.tooltip}</span>
        </div> */}
        <div className="relative group">
          <MdInfoOutline
            className="text-primary cursor-pointer"
            onClick={() => setShowTooltip(!showTooltip)}
          />
          {/* Tooltip */}
          <div
            className={`absolute ${showTooltip ? "flex" : "hidden"} group-hover:flex items-center ${
              props.position === "top"
                ? "bottom-full mb-3 left-1/2 transform -translate-x-1/2"
                : props.position === "right"
                  ? "left-full ml-3 top-1/2 transform -translate-y-1/2"
                  : props.position === "left"
                    ? "right-full mr-3 top-1/2 transform -translate-y-1/2"
                    : props.position === "bottom"
                      ? "top-full mt-3 left-1/2 transform -translate-x-1/2"
                      : "right-full mr-3 top-1/2 transform -translate-y-1/2"
            } bg-[#EFEFEF] bg-opacity-100 z-50 text-black text-[12px] leading-5 p-3 rounded-lg max-w-[280px] min-w-[200px] shadow-lg`}
          >
            {/* Tooltip Arrow */}
            {props.position === "top" && (
              <div className="absolute bottom-[-8px] left-1/2 transform -translate-x-1/2 w-0 h-0 border-x-8 border-x-transparent border-t-8 border-t-[#EFEFEF]"></div>
            )}
            {props.position === "right" && (
              <div className="absolute -left-2 top-1/2 transform -translate-y-1/2 w-0 h-0 border-y-8 border-y-transparent border-r-8 border-r-[#EFEFEF]"></div>
            )}
            {props.position === "bottom" && (
              <div className="absolute top-[-8px] left-1/2 transform -translate-x-1/2 w-0 h-0 border-x-8 border-x-transparent border-b-8 border-b-[#EFEFEF]"></div>
            )}
            {props.position === "left" && (
              <div className="absolute -right-2 top-1/2 transform -translate-y-1/2 w-0 h-0 border-y-8 border-y-transparent border-l-8 border-l-[#EFEFEF]"></div>
            )}
            <div className="whitespace-normal break-words">{props.tooltip}</div>
          </div>
        </div>
      </label>
      <input
        required={props.required || false}
        type="number"
        inputMode="numeric"
        min="0"
        max="100"
        placeholder={props.placeholder}
        value={inputValue}
        onChange={handleChange}
        onWheel={(e) => e.currentTarget.blur()}
        onKeyDown={(e) => {
          if (
            e.key === "-" ||
            e.key === "e" ||
            e.key === "E" ||
            e.key === "+"
          ) {
            e.preventDefault();
          }
        }}
        className="border px-4 rounded-lg h-10 text-base border-[#c9c9c9]"
      />
    </div>
  ));
}
